"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
require("./selector.scss");
const displayWrapper_1 = require("./common/displayWrapper");
const legacyFirestore_1 = require("./hooks/legacyFirestore");
const selector_1 = __importDefault(require("./selector"));
const hooks_1 = require("common/hooks");
const components_1 = require("utils/components");
const ExternalKeyComponent = (props) => {
    const { schema: originalSchema } = props;
    const { staticOptions, order } = originalSchema, originalSchemaExceptStaticOptions = __rest(originalSchema, ["staticOptions", "order"]);
    const { list: options } = (0, legacyFirestore_1.useQueryResource)(originalSchema);
    // optionsのtitleでソートする
    const sortedOptions = (0, react_1.useMemo)(() => {
        if (!options || !order) {
            return options;
        }
        const sortedOptions = [...options];
        sortedOptions.sort((a, b) => {
            if (a.title < b.title) {
                return order === "asc" ? -1 : 1;
            }
            if (a.title > b.title) {
                return order === "asc" ? 1 : -1;
            }
            return 0;
        });
        return sortedOptions;
    }, [options]);
    const mergedOptions = (0, react_1.useMemo)(() => {
        if (!staticOptions) {
            return sortedOptions;
        }
        return [...staticOptions, ...(sortedOptions || [])];
    }, [sortedOptions, staticOptions]);
    const schema = (0, react_1.useMemo)(() => {
        return Object.assign(Object.assign({}, originalSchemaExceptStaticOptions), { schemaType: "selector", options: mergedOptions || [] });
    }, [originalSchemaExceptStaticOptions, mergedOptions]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(selector_1.default, Object.assign({}, props, { schema: schema }))));
};
ExternalKeyComponent.display = (0, displayWrapper_1.DisplayComponent)("ExternalKeyComponent", (value, schema) => {
    const s = (0, hooks_1.useStringIntl)();
    const { resourcePath, titleKey } = schema;
    const { data } = (0, legacyFirestore_1.useDocResource)(resourcePath, value);
    const { list: options } = (0, legacyFirestore_1.useQueryResource)(schema);
    const convertedStaticOptions = (schema.staticOptions || []).map((r) => {
        return {
            title: r.title,
            value: `${r.value}`,
        };
    });
    const optionMap = (0, legacyFirestore_1.toMap)([...(options || []), ...convertedStaticOptions]);
    console.log("optionMap", optionMap, value);
    if (!value) {
        return "未設定";
    }
    if (schema.href) {
        return value && data ? (react_1.default.createElement(components_1.Link, { className: "", to: schema.href(value, data) }, s(data === null || data === void 0 ? void 0 : data[titleKey]))) : (s(optionMap === null || optionMap === void 0 ? void 0 : optionMap.get(value)) || "");
    }
    else {
        return s(optionMap === null || optionMap === void 0 ? void 0 : optionMap.get(value)) || "";
    }
});
exports.default = ExternalKeyComponent;
